import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";

import { muiAbtn, muiBbtn } from "./style";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import CreativeImage from "./CreativeImage";
import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function Countries() {
  const [rows, setRows] = useState([]);
  const [isupdate, setisupdate] = useState(false);
  const [loading, setLoading] = useState(false); ///To check if data if loaded or not from collection.
  const [isProcessing, setisProcessing] = useState(false);
  const [openMission, setOpenMission] = useState(false);
  const [open, setOpen] = useState(false);
  const [Name, setName] = useState("");
  const [CountryCode, setCountryCode] = useState("");
  const [DocId, setDocId] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [EinnewsLink, setEinnewsLink] = useState("");
  const [selectedMissionsIn, setSelectedMissionsIn] = useState([]);
  const [selectedMissionsOf, setSelectedMissionsOf] = useState([]);

  const navigate = useNavigate();
  const getData = () => {
    setLoading(true);

    const q = query(collection(db, "countries"), orderBy("name", "asc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const updatedRows = [];
      snapshot.forEach((document) => {
        updatedRows.push({
          id: document.id,
          ...document.data(),
        });
      });
      setRows(updatedRows);
      setLoading(false);
    });

    return unsubscribe;
  };

  // ...

  useEffect(() => {
    let unsubscribe;
    let active = true;

    if (active) {
      unsubscribe = getData();
    }

    return () => {
      active = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  const handleOpen = () => {
    setOpen(true);
    setName("");
  };

  const handleOpenMission = (row, id) => {
    setOpenMission(true);
    setName(row.name);
    setCountryCode(row.code);
    setSelectedMissionsIn(row.missionsIn);
    setSelectedMissionsOf(row.missionsOf);
    setDocId(id);
    setisupdate(true);
  };
  const handleOpenUpdate = (
    name = "",
    code = "",
    id = "",
    einnewsLink = ""
  ) => {
    setisupdate(true);
    setName(name);
    setCountryCode(code);
    setDocId(id);
    setOpen(true);
    setEinnewsLink(einnewsLink);
  };
  const handleClose = () => {
    setOpen(false);
    setName("");
    setisupdate(false);
    setisProcessing(false);
    setEinnewsLink("");
  };
  const handleCloseMission = () => {
    setOpenMission(false);
    setName("");
    setisupdate(false);
    setisProcessing(false);
    setName("");
    setCountryCode("");
    setSelectedMissionsIn([]);
    setSelectedMissionsOf([]);
  };

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setDocId(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDocId("");
    setisProcessing(false);
  };

  const deleteCountry = () => {
    setisProcessing(true);
    deleteDoc(doc(db, "countries", DocId))
      .then(() => {
        toast.info("Country Deleted");
        handleCloseDialog();
        setRows(rows.filter((row) => row.id !== DocId));
      })
      .catch((error) => {
        handleCloseDialog();
        toast.error("Error! Unable to Delete Country");
        console.log(error);
      });
  };

  const handleAutocompleteChange = (event, newValue) => {
    // Map the selected items to objects containing name and code properties
    const selectedCountries = newValue.map((name) => {
      const country = rows.find((country) => country.name === name);
      return { name: country.name, code: country.code };
    });

    setSelectedMissionsIn(selectedCountries);
  };
  const handleAutocompleteChange1 = (event, newValue) => {
    // Map the selected items to objects containing name and code properties
    const selectedCountries = newValue.map((name) => {
      const country = rows.find((country) => country.name === name);
      return { name: country.name, code: country.code };
    });

    setSelectedMissionsOf(selectedCountries);
  };
  const addCountry = () => {
    if (!Name || !CountryCode) {
      toast.error("Country name and code are required");
      return;
    }
    setisProcessing(true);
    const data = {
      name: Name,
      einnewsLink: EinnewsLink,
      code: CountryCode,
      missionsIn: selectedMissionsIn,
      missionsOf: selectedMissionsOf,
    };

    if (isupdate) {
      updateDoc(doc(db, "countries", DocId), data)
        .then(() => {
          handleClose();
          handleCloseMission();
          toast.success("Country Updated");
        })
        .catch((error) => {
          handleClose();
          handleCloseMission();
          toast.error("Error! Unable to Update Country");
          console.log(error);
        });
    } else {
      const newDoc = doc(collection(db, "countries"));
      const doc_id = newDoc.id;
      setDoc(newDoc, data)
        .then(() => {
          handleClose();
          handleCloseMission();
          toast.success("Country Added");
        })
        .catch((error) => {
          handleClose();
          handleCloseMission();
          toast.error("Error! Unable to Add Country");
          console.log(error);
        });
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: "60" },
    {
      field: "name",
      headerName: "",
      width: "500",
      align: "left",
    },
    {
      field: "code",
      headerName: "",
      width: "70",
      align: "left",
    },

    {
      field: "Action",
      width: "400",
      align: "right",

      editable: false,
      renderCell: ActionButton,
    },
  ];

  function ActionButton(params) {
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          onClick={() => handleOpenMission(params.row, params.row.id)}
        >
          Missions
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          onClick={() => navigate("/ViewCountryNews/" + params.row.id)}
        >
          News
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          // startIcon={<CheckCircleIcon />}
          onClick={() => {
            handleOpenUpdate(
              params.row.name,
              params.row.code,
              params.row.id,
              params.row?.einnewsLink
            );
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          onClick={() => handleClickOpen(params.row.id)}
          // startIcon={<CancelIcon />}
        >
          Delete
        </Button>
      </>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,
        backgroundColor: "#212C62",
      }}
    >
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to Delete the Country?"}
        </DialogTitle>

        {isProcessing ? (
          <LinearProgress />
        ) : (
          <DialogActions>
            <Button onClick={() => deleteCountry()}>Yes</Button>
            <Button onClick={handleCloseDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        )}
      </Dialog>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <Box style={{ display: "flex", justifyContent: "end" }}>
              <CloseIcon
                onClick={handleClose}
                style={{ cursor: "pointer", color: "gray" }}
              />
            </Box>
            <h2 className="mb-4" style={{ color: "#212C62" }} mb={3}>
              {!isupdate ? "Add New Country" : "Update Country"}
            </h2>

            <FormControl fullWidth size="small">
              <TextField
                className="mb-4"
                id="outlined-basic"
                label="Enter Name"
                variant="outlined"
                size="small"
                fullWidth
                value={Name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>
            <FormControl fullWidth size="small">
              <TextField
                className="mb-4"
                id="outlined-basic"
                label="Country Code"
                variant="outlined"
                size="small"
                fullWidth
                value={CountryCode}
                onChange={(e) => setCountryCode(e.target.value)}
              />
            </FormControl>
            <FormControl fullWidth size="small">
              <TextField
                className="mb-4"
                id="outlined-basic"
                label="Einnews Link"
                variant="outlined"
                size="small"
                fullWidth
                value={EinnewsLink}
                onChange={(e) => setEinnewsLink(e.target.value)}
              />
            </FormControl>

            <Button
              fullWidth
              className="mt-2 muibtn"
              variant="contained"
              color="primary"
              size="small"
              style={muiBbtn}
              disabled={isProcessing}
              onClick={() => addCountry()}
            >
              {isProcessing ? (
                <CircularProgress sx={{ color: "white" }} size={27} />
              ) : (
                <>
                  <AddIcon style={{ marginRight: 10 }} />
                  {!isupdate ? "Add Country" : "Update Country"}
                </>
              )}
            </Button>
          </form>
        </Box>
      </Modal>
      <Modal
        open={openMission}
        onClose={handleCloseMission}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <Box style={{ display: "flex", justifyContent: "end" }}>
              <CloseIcon
                onClick={handleCloseMission}
                style={{ cursor: "pointer", color: "gray" }}
              />
            </Box>
            <h2>
              {Name} - {CountryCode}
            </h2>
            <FormControl fullWidth size="small" className="mb-4">
              <Autocomplete
                multiple
                id="missionsIn"
                options={rows.map((country) => country.name)}
                value={selectedMissionsIn.map((country) => country.name)}
                onChange={handleAutocompleteChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Missions In"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>

            <FormControl fullWidth size="small" className="mb-4">
              <Autocomplete
                multiple
                id="missionsOf"
                options={rows.map((country) => country.name)}
                value={selectedMissionsOf.map((country) => country.name)}
                onChange={handleAutocompleteChange1}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Missions Of"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>

            <Button
              fullWidth
              className="mt-2 muibtn"
              variant="contained"
              color="primary"
              size="small"
              style={muiBbtn}
              disabled={isProcessing}
              onClick={() => addCountry()}
            >
              {isProcessing ? (
                <CircularProgress sx={{ color: "white" }} size={27} />
              ) : (
                <>
                  <AddIcon style={{ marginRight: 10 }} />
                  Update Country
                </>
              )}
            </Button>
          </form>
        </Box>
      </Modal>

      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6">
            <h1
              className="mb-4 py-4"
              style={{ textAlign: "left", color: "#212C62" }}
            >
              <b>All Contries</b>
            </h1>
            <Button
              variant="contained"
              color="primary"
              style={muiBbtn}
              size="small"
              // startIcon={<CheckCircleIcon />}
              onClick={() => handleOpen()}
            >
              Add New Country
            </Button>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>All Contries</b>
          </h5>
          <DataGrid
            style={{ height: "65vh", width: "100%" }}
            columns={columns}
            rows={rows}
            // getRowId={(Rows) => Rows._id}
            pageSize={12}
            rowsPerPageOptions={[12]}
            loading={loading}
            disableColumnMenu={true}
            headerHeight={0}
            getRowSpacing={(params) => ({
              top: params.isFirstVisible ? 10 : 8,
              bottom: params.isLastVisible ? 0 : 8,
            })}
            disableSelectionOnClick
          />
        </div>
      </Card>
    </div>
  );
}
